/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type CashbackShow_cashback$ref = any;
export type CashbackShowQueryVariables = {|
  cashbackId: string
|};
export type CashbackShowQueryResponse = {|
  +cashback: ?{|
    +$fragmentRefs: CashbackShow_cashback$ref
  |}
|};
export type CashbackShowQuery = {|
  variables: CashbackShowQueryVariables,
  response: CashbackShowQueryResponse,
|};
*/


/*
query CashbackShowQuery(
  $cashbackId: ID!
) {
  cashback(id: $cashbackId) {
    ...CashbackShow_cashback
    id
  }
}

fragment CashbackShow_cashback on Cashback {
  id
  date
  name
  rate
  amount
  source
  pended
  plaidTransactionId
  transactionAmount
  fastCashId
  state
  quarantinedReason
  availableStates
  userAuth0Id
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cashbackId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "cashbackId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CashbackShowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Cashback",
        "kind": "LinkedField",
        "name": "cashback",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CashbackShow_cashback"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CashbackShowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Cashback",
        "kind": "LinkedField",
        "name": "cashback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pended",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "plaidTransactionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transactionAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fastCashId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quarantinedReason",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availableStates",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userAuth0Id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CashbackShowQuery",
    "operationKind": "query",
    "text": "query CashbackShowQuery(\n  $cashbackId: ID!\n) {\n  cashback(id: $cashbackId) {\n    ...CashbackShow_cashback\n    id\n  }\n}\n\nfragment CashbackShow_cashback on Cashback {\n  id\n  date\n  name\n  rate\n  amount\n  source\n  pended\n  plaidTransactionId\n  transactionAmount\n  fastCashId\n  state\n  quarantinedReason\n  availableStates\n  userAuth0Id\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '35b571dcae7f0929878a2f57e4687cb3';

module.exports = node;
